import React from 'react';
// import Schedule from './schedule'
// import {wsTrans} from '../../utils/utils'
import styles from './pearlDoser.module.css'
import LoadingSpinner from '../loadingSpinner'
import {cl,globs,getRandomString} from '../../../components/utils/utils';

class DoserCloud extends React.Component{
  constructor(props) {
    super(props);
    this.state={
      loaded:true,
    }
  }

  componentDidMount=()=>{
    this.loadInfo()
  }

  loadInfo=async()=>{
  }

  render(){
    let st=this.state
    if(st.loaded){
      return(
        <div className={styles.pearlDoser}
        style={{padding:20}}
          onMouseDown={this.pageMouseDown}
        >
          <h3>Cloud Page</h3>
        </div>
      )
    }else{
      return <LoadingSpinner message="loading accesses..." />
    }
  }
}

export default DoserCloud;
